"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Portal = void 0;
const React = __importStar(require("react"));
const ReactDOM = __importStar(require("react-dom"));
const dev_note_1 = __importDefault(require("@xingternal/dev-note"));
class Portal extends React.Component {
    constructor() {
        super(...arguments);
        this.state = {
            mounted: false,
        };
    }
    componentDidMount() {
        if (this.props.containerId) {
            this.portalContainer = document.getElementById(this.props.containerId);
        }
        else {
            this.portalContainer = document.createElement('div');
        }
        // eslint-disable-next-line
        this.setState({
            mounted: true,
        });
        if (!this.props.containerId) {
            document.body.appendChild(this.portalContainer);
        }
    }
    componentWillUnmount() {
        if (!this.props.containerId) {
            document.body.removeChild(this.portalContainer);
        }
    }
    render() {
        if (!this.state.mounted) {
            return null;
        }
        if (this.props.containerId &&
            !document.getElementById(this.props.containerId)) {
            dev_note_1.default.warn('You passed a containerId to @xingternal/portal but we could not find the container in your DOM. Nothing is rendered now. Please check why the container is not present.');
            return null;
        }
        return ReactDOM.createPortal(this.props.children, this.portalContainer);
    }
}
exports.Portal = Portal;
//# sourceMappingURL=portal.js.map